module.exports = __webpack_public_path__ + "static/media/stairs-white.d031b273.png";